import { camelCase, includes, isArray, isPlainObject, snakeCase } from 'lodash';

export const transformOutgoingData = <T>(data: T): T => transformData(data, snakeCase);
export const transformIncomingData = <T>(data: T): T => transformData(data, camelCase);

const transformData = <T>(data: T, transformer: (value: string) => string) => {
  if (isPlainObject(data)) {
    const newObj: Record<string, unknown> = {};

    for (const key in data) {
      newObj[transformer(key)] = transformData(data[key], transformer);
    }

    return newObj;
  } else if (isArray(data)) {
    return data.map((item) => transformData(item, transformer));
  }

  return data;
};

export const shouldTransformOutgoingMethod = (method: string | undefined): boolean =>
  includes(['put', 'post', 'patch'], method);
